const scrollToTop = () => {
    /* eslint-disable no-undef */
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    /* eslint-enable no-undef */
 };

 export { scrollToTop };

